/*
 * helpers
 */
// import './verticalGrid'
document.documentElement.classList.remove('_nojs')
document.documentElement.classList.add(
  'ontouchstart' in document.documentElement ? '_touch' : '_notouch',
)

/*
 * Application
 */
import { main } from './main'
import { run } from '@cycle/run'
import { timeDriver } from '@cycle/time'
import makeInteractionDriver from './drivers/interactionDriver'
import makeDOMmutationDriver from './drivers/DOMmutationDriver'

const drivers = {
  Screen: makeInteractionDriver(window),
  DOM: makeDOMmutationDriver(window),
  Time: timeDriver,
}

run(main, drivers)



// WEBPACK FOOTER //
// ./index.js